var React = require('react');
var BaseClassComponent = require('../../shared/base.jsx');

class TextComponent extends BaseClassComponent {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onCustomValueChanged(this.props.customFieldDefinition, e.currentTarget.value);
    }

    render() {
        let txtValue = '';
      //  console.log("CF profile")
     //   console.log(this.props.customFieldDefinition)
        if(
            this.props.customFieldDefinition.Name !== process.env.NAME_CF_CLIENTE_ID &&
            this.props.customFieldDefinition.Name !== process.env.NAME_CF_CLIENTE_CONSULTA &&
            this.props.customFieldDefinition.Name !== process.env.NAME_CF_VENDEDOR_ID
        ){

            if (this.props.customFieldValues && this.props.customFieldValues.Values) {
                txtValue = this.props.customFieldValues.Values[0];
            }
            let css = "input-text ";
            if (this.props.customFieldDefinition.IsMandatory) {
             //   css += "required";
            }
            return (
                <div className="input-container"> <span className="additional-one lbl-profile">{this.props.customFieldDefinition.Name}</span>
                    <input id="input-profile-cf" type="text" className={css} name="additional-one" placeholder="" onChange={this.onChange} defaultValue={txtValue} />
                </div>
            )
        }
        return ""
        
    }
}

module.exports = TextComponent;